import React from "react";
import { Page, Card, Text } from "@shopify/polaris";
import { useEnsureInstall } from "../hooks/useEnsureInstall";
import Dashboard from "./Dashboard";
import { DashboardPageSkeleton } from "../components/PageSkeleton";

export default function Home() {
  const { installLoading, isRedirecting, isReady, installError } = useEnsureInstall();

  if (installLoading || isRedirecting) {
    return <DashboardPageSkeleton />;
  }

  if (!isReady) {
    return (
      <Page>
        <Card>
          <Text as="p" tone="critical">
            {installError || "Checking installation…"}
          </Text>
        </Card>
      </Page>
    );
  }

  return <Dashboard />;
}
